import SettingsTemplate from "components/templates/SettingsTemplate"

const Settings = () => {
  return <SettingsTemplate />
}

export default Settings
